<template>
    <div class="vw-100 h-100 d-flex flex-row">
        <aside>
            <div class="header py-2 px-3" style="z-index: 99">
                <a class="me-2 fs-3 text-dark cp btn-rounded btn-default btn d-block d-lg-none" @click="toggle"><i class="mdi mdi-arrow-left"></i></a>
                <h5 class="m-0">Versatech University</h5>
                <div class="flex-1 d-flex flex-row justify-content-end align-items-center">
                    <button class="btn btn-default btn-rounded text-primary" @click="$emitter.emit('show_add_topic', {callback:addTopic});" v-if="getRole === 'A'"><i class="mdi mdi-plus-circle fs-20"></i></button>
                    <button class="btn btn-default btn-rounded" @click="refresh"><i class="mdi mdi-refresh fs-20"></i></button>
                </div>
            </div>
            <div class="flex-1 position-relative w-100 h-100">
                <div class="position-absolute w-100 h-100 overflow-auto pt-0 p-3" v-if="menus.length > 0 && !menus_loading">
                    <nav class="nav nav-pills flex-column side-menu" :data-uid="menu.uid" v-for="(menu, index) in menus" :key="index">
                        <div class="nav-link mw-100" :class="{'nav-active':menu.uid == $route.params.child_id}" @mouseover="hover[menu.uid] = true" @mouseout="hover[menu.uid] = false">
                            <span class="d-flex align-items-center w-100 mw-100 nav-link-child text-truncate" @click="$router.replace(`/vuniversity/${menu.uid}`);">
                                {{menu.name}}
                            </span>
                            <div v-show="hover[menu.uid]" v-if="menu.admin === true">
                                <div class="d-flex flex-row">
                                    <div class="dropdown">
                                        <a class="option-item dropdown-toggle text-dark" data-bs-toggle="dropdown"><i class="mdi mdi-dots-vertical"></i></a>
                                        <ul class="dropdown-menu">
                                            <li><button class="dropdown-item" type="button" @click="$emitter.emit('show_add_topic', {callback:updateTopic,data:menu.name,parent:menu.id});"><i class="mdi mdi-pencil"></i> Edit</button></li>
                                            <li><button class="dropdown-item" type="button" @click="$emitter.emit('delete_modal_show', [deleteTopic, menu.id]);"><i class="mdi mdi-trash-can"></i> Move to Trash</button></li>
                                        </ul>
                                    </div>
                                    <a class="option-item text-primary" @click="$emitter.emit('show_add_topic', {callback:addTopic,parent:menu.id});"><i class="mdi mdi-plus-circle"></i></a>  
                                </div>
                            </div>

                            <a class="option-item me-2" v-if="menu.menu.length > 0" @click="show[menu.uid] = !show[menu.uid];"><i class="mdi" :class="{'mdi-chevron-down':!show[menu.uid], 'mdi-chevron-up':show[menu.uid]}"></i></a>

                        </div>
                        <transition name="fade">
                            <SubMenu :menus="menu.menu" :index="menu.uid" v-show="show[menu.uid]"/>
                        </transition>
                    </nav>
                </div>
                <div class="w-100 h-100 d-flex flex-column p-3 opacity-3" v-else-if="menus_loading">
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                </div>
                <div class="w-100 h-100 d-flex flex-column align-items-center justify-content-center opacity-3" v-else>
                    <i class="mdi mdi-menu h-auto" style="font-size: 100px;"></i>
                    <span class="fw-500">No menus found</span>
                </div>
            </div>
            <div class="d-grid gap-1 p-1" v-if="getRole === 'A'">
                <button class="btn btn-primary text-start" @click="$emitter.emit('show_add_vu', {callback:addContent});"><i class="mdi mdi-plus mx-2"></i> New Content</button>
                <button class="btn btn-danger text-start" disabled><i class="mdi mdi-trash-can mx-2"></i>Trash</button>
            </div>
        </aside>
        <div class="container align-items-center d-flex flex-column position-relative">
            <button class="btn btn-secondary position-fixed d-block d-lg-none" style="top: 110px; left:10px;z-index:1" @click="toggle">Menu</button>
            <div class="position-absolute overflow-auto w-100 h-100" style="background-color: #f9f9f975;" v-if="videos.length > 0 && !videos_loading">
                <div class="p-3">
                    <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
                        <div class="col" v-for="(video, index) in videos" :key="index">
                            <div class="card border-0 shadow-sm cp" @mouseover="hover[index+'card'] = true" @mouseout="hover[index+'card'] = false" v-if="video.uid !== ''">
                                <div class="position-absolute" style="top:5px;right:5px;" v-show="hover[index+'card']" v-if="video.admin === true">
                                    <div class="dropdown">
                                        <a href="" class="option-item dropdown-toggle bg-primary text-white px-1" data-bs-toggle="dropdown"><i class="mdi mdi-dots-vertical"></i></a>
                                        <ul class="dropdown-menu">
                                            <li><button class="dropdown-item" type="button" @click="$emitter.emit('show_add_vu', {callback:updateContent,data:{index:index, title:video.content_name,content:video.content,type:video.type}});"><i class="mdi mdi-pencil"></i> Edit</button></li>
                                            <li><button class="dropdown-item" type="button" @click="copyURL(video.uid)"><i class="mdi mdi-link"></i> Get Url</button></li>
                                            <li><button class="dropdown-item" type="button" @click="$emitter.emit('delete_modal_show', [deleteContent, video.id]);"><i class="mdi mdi-trash-can"></i> Move to Trash</button></li>
                                        </ul>
                                    </div>
                                </div>
                                <template v-if="video.type != 'link'">
                                    <img :src="video.thumbnail" class="card-img-top" @click="open(video)" >
                                </template>
                                <template v-else>
                                    <img src="../assets/v_parent/vu.gif"  @click="open(video)" />

                                </template>
                                <div class="card-body" @click="open(video)" >
                                    <p class="card-text m-0 fw-600 text-muted ellipsis-2">{{video.content_name}}</p>
                                    <small>{{video.date}}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-100 h-100 d-flex flex-column p-3 opacity-3" v-else-if="videos_loading">
                <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
                    <div class="col" style="height: 200px;"><div class="shimmer"></div></div>
                    <div class="col" style="height: 200px;"><div class="shimmer"></div></div>
                    <div class="col" style="height: 200px;"><div class="shimmer"></div></div>
                    <div class="col" style="height: 200px;"><div class="shimmer"></div></div>
                    <div class="col" style="height: 200px;"><div class="shimmer"></div></div>
                    <div class="col" style="height: 200px;"><div class="shimmer"></div></div>
                    <div class="col" style="height: 200px;"><div class="shimmer"></div></div>
                    <div class="col" style="height: 200px;"><div class="shimmer"></div></div>
                </div>
            </div>
            <div class="w-100 h-100 d-flex flex-column align-items-center justify-content-center" style="background: #fdfdfd;" v-else>
                <img src="../assets/v_parent/vu.gif" />
            </div>
        </div>
    </div>
            
    <div class="position-fixed bg-white details overflow-hidden">
        <div class="position-relative h-100 w-100">
            <div class="d-flex flex-column h-100">
                <header class="bg-white d-flex flex-row justify-content-between align-items-center">
                    <div class="d-flex flex-row align-items-center p-2">
                        <a class="me-2 fs-3 text-dark cp btn-rounded btn-default btn" @click="open(-1)"><i class="mdi mdi-arrow-left"></i></a>
                        <h5 class="m-0 text-truncate" ref="container_title"></h5>
                    </div>
                </header>
                <div class="flex-1 w-100" ref="container">

                </div>
            </div>
        </div>
    </div>

    <AddVuniversityModal />
</template>

<script>
import SubMenu from './subviews/SubMenu';
import AddVuniversityModal from './modal/AddVuniversityModal';

export default {
    components: {
        SubMenu,
        AddVuniversityModal,
    },
    data() {
        return {
            announcements: [],
            appname: process.env.VUE_APP_APPNAME,
            menus_loading: true,
            menus: [],  
            hover: {},
            show: {},
            temp: [],
            videos: [],
            videos_loading: true
        }
    },
    computed: {
        getRole() {
            try {
                var json = JSON.parse(localStorage.getItem('versatechvex_data'));
                if(json.role !== undefined) return json.role;
                else return 'U';
            }
            catch(e) {
                return 'U';
            }
        }
    },
    methods: {
        toggle() {
            let aside = document.getElementsByTagName('aside');
            if(aside[0] !== undefined) {
                if(aside[0].classList.contains('show')) aside[0].classList.remove('show');
                else aside[0].classList.add('show');
            }
        },
        async addTopic(topic, parent = '') {
            if(topic.toString().length == 0) return this.$jlalert.show('Topic cannot be empty');
            await this.$axios.post('/menus/vuniversity', this.$qs.stringify({topic:topic,parent:parent}))
                    .then((res) => {
                        if(res.status == 200) {
                            //this.menus = [];
                            this.loadMenus();
                        }
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
        },
        async updateTopic(topic, id) {
            await this.$axios.post('/menus/vuniversity/update', this.$qs.stringify({topic:topic,id:id}))
                    .then((res) => {
                        if(res.status == 200) {
                            //this.menus = [];
                            this.loadMenus();
                        }  

                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$$jlalert.show(err);
                    });
        },
        copyURL(id = '') {
            var dummy = document.createElement("textarea");
            // to avoid breaking orgain page when copying more words
            // cant copy when adding below this code
            // dummy.style.display = 'none'
            document.body.appendChild(dummy);
            //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
            dummy.value = window.location.protocol+'//'+window.location.host+`/vuniversity/${this.$route.params.child_id}`+(id == '' ? '' : '?content='+id);
            dummy.select();
            document.execCommand("copy");
            document.body.removeChild(dummy);
            this.$jlalert.show('Url copied', false);
        },
        open(index) {
            let details = document.querySelector('.details');
            if(index == -1) {
                this.$refs.container.innerHTML = '';
                this.$refs.container_title = '';
                details.classList.remove('show');
            }
            else {

                if(index.type != 'link'){
                    details.classList.add('show');

                    var iframe = document.createElement('iframe');
                    iframe.setAttribute('width', '100%');
                    iframe.setAttribute('height', '100%');
                    iframe.setAttribute('frameborder', '0');
                    iframe.setAttribute('allowfullscreen', true);
                    iframe.setAttribute('src', index.content)
                    this.$refs.container.appendChild(iframe);

                    this.$refs.container_title.innerHTML = index.content_name;
                    this.$router.push({query:{content:index.uid}});
                }
                else{
                    console.log(index)
                    window.open(index.content, "_blank" );   
                }

            }
        },
        async loadMenus(load = false) {
            if(load == true) this.menus_loading = true;
            
            await this.$axios.get('/menus/vuniversity')
                    .then((res) => {
                        this.menus = res.data;
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
            this.menus_loading = false;
        },
        refresh() {
            this.menus = [];
            this.videos = [];
            if(this.$route.params.child_id !== undefined) this.openTopic(this.$route.params.child_id);
            this.loadMenus(true);
        },
        async deleteTopic(id) {
            await this.$axios.delete(`/menus/vuniversity/${id}`)
                    .then((res) => {
                        if(res.status == 200) {
                            this.$router.replace('/vuniversity');
                            this.loadMenus();
                        }
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    })
        },
        async openTopic(uid) {
            await this.$axios.get(`/content/vuniversity/${uid}`)
                    .then((res) => {
                        this.videos = res.data;
                        if(this.$route.query.content !== undefined) {
                            this.videos.forEach(element => {
                                if(element.uid === this.$route.query.content) return this.open(element);
                            });
                        }
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
            this.videos_loading = false;
        },
        reset() {
            this.videos_loading = true;
            this.videos = [];
        },
        async updateContent(index, title, content, type) {
            await this.$axios.post('/content/vuniversity/update', this.$qs.stringify({id:this.videos[index].id,title:title,content:content,type : type}))
                    .then((res) => {
                        if(res.status == 200) {
                            this.videos[index].content_name = title;
                            this.videos[index].content = content;
                        }
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    })
                    
        },
        closeel(element) {
            if(element == null) return;
            var parent = element.parentElement;
            var nav = parent.parentElement;
            if(nav.tagName == 'NAV') {
                this.temp.push(nav);
                let link = nav.querySelectorAll('.nav-link');
                if(link[0] !== null && link[0] !== undefined) {
                    this.closeel(nav);
                }
            }
            else this.initClick();
        },
        initClick() {
            for (var i = this.temp.length - 1; i >= 0; i--) {
                let target = this.temp[i];
                let link = target.querySelectorAll('.nav-link');
                if(link[0] !== null && link[0] !== undefined) {
                    link[0].click();
                }
            }
        },
        async addContent(index, title, content,type) {

            await this.$axios.post(`/content/vuniversity/insert`, this.$qs.stringify({title:title,content:content,id:this.$route.params.child_id,type:type}))
                    .then((res) => {
                        if(res.status == 200) this.openTopic(this.$route.params.child_id);
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
        },
        async deleteContent(id) {
            for(var i = 0; i < this.videos.length; i++) {
                if(this.videos[i].id == id) {
                    this.videos.splice(i, 1);
                }
            }
            await this.$axios.delete(`/content/vuniversity/${id}`)
                    .then((res) => {
                        if(res.status == 200) this.openTopic(this.$route.params.child_id);
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    })
        }
    },
    mounted() {
        this.loadMenus(true);

        this.$emitter.on('addTopic', (data) => {
            this.addTopic(data[0], data[1]);
        });

        this.$emitter.on('updateTopic', (data) => {
            this.updateTopic(data[0], data[1]);
        });

        this.$emitter.on('deleteTopic', (data) => {
            this.deleteTopic(data);
        });

        this.$emitter.on('openTopic', (data) => {
            this.$router.replace(`/vuniversity/${data}`);
        });

        if(this.$route.params.child_id !== undefined) this.openTopic(this.$route.params.child_id);
        else this.videos_loading = false;
    },
    watch: {
        "$route.params.child_id": function(n) {
            this.reset();
            if(n == undefined) {
                this.videos_loading = false;
                return;
            }
            this.openTopic(n)
            let details = document.querySelector('.details');
            if(details !== null && details !== undefined) details.classList.remove('show');
        },
        "menus": function(n) {
            if(n.length > 0 && this.$route.params.child_id !== undefined) {
                setTimeout(() => {
                    var element = document.querySelector(`[data-uid="${this.$route.params.child_id}"]`);
                    this.closeel(element);
                }, 200);
            }
        }
    }
}
</script>

<style scoped>
.details {
    right: -100vw;
    transition: 0.3s ease;
    width: 69vw;
    top: 98px;
    z-index: 999;
    height:calc(100vh - 98px);
}

.details iframe {
    width: 100% !important;
    height: 100% !important;
}

.details.show {
    right: 0;
}

.dropdown-menu {
    border-radius: 3px;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
    border: 0.4px solid #ffffff;
    padding: 0;
    width: 20vw;
}

aside {
    width: 45vw;
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    transition: 0.3s ease;
}

.container {
    max-width: 100%;
}

.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.bg-primary {
    background-color: var(--primary-color) !important;
}

.text-primary {
    color: var(--primary-color) !important;
}

@media screen and (max-width: 991px) {
    aside {
        position: absolute;
        left: -100vw;
        width: 100vw;
        z-index: 999;
        background: #fff;
        height: calc(100vh - 98px) !important;
    }

    aside.show {
        left: 0;
    }

    .container {
        width: 100%;
        max-width: 100%;
    }

    .details {
        width: 100vw;
    }
}

.side-menu nav {
    margin-bottom: 0;
}

.side-menu .nav-link {
    border-radius: 4px;
    padding: 5px 10px;
    font-weight: 600;
    color: #585858;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    height: 38px;
}

.side-menu .nav-link:hover, .side-menu .nav-link.nav-active {
    background: #efefef;
}

.option-item {
    padding: 0 7px;
    border-radius: 4px;
    justify-content: center;
    transition: 0.3s;
    font-size: 19px;
    font-weight: 500;
}

.option-item:hover {
    background: #c9c9c96b;
}

.dropdown-toggle::after {
    display: none !important;
}

.dropdown-item {
    font-size: 14px;
    font-weight: 600;
    color: #424242d4;
    padding: 7px 16px;
}

.dropdown-item .mdi {
    margin-right: 10px;
    opacity: 0.4;
}

.dropdown-item.active, .dropdown-item:active {
    background-color: #6696e8;
    color: #fff;
}
</style>